export enum OnboardingStep {
  Birthday = "birthday",
  Name = "name",
  Username = "username",
  ProfilePhoto = "profile-photo",
  Welcome = "welcome",
}

export interface UserData {
  birthday: string;
  name: string;
  username: string;
  photoURL: string;
}
